import React from 'react'
import { Snackbar, Link, Button } from '@material-ui/core'
import Config from 'config'
import { useDispatch } from 'react-redux'
import { closeCookiesSnackbar } from 'utils/common/actions'
import useStyles from './styles'


const CookiesSnackbar = (props) => {
  const {
    open
  } = props
  const dispatch = useDispatch()
  const localClasses = useStyles()
  const { policyUrl } = Config.contacts

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={open}
      
    >
      <div className={localClasses.cookiesSnackbar}>
        This site uses cookies to provide with more responsive and personalised service. By using this site you agree to our use of cookies.<br/>
        See our <Link className={localClasses.privacyLink} href={policyUrl} target='_blank' underline='always'>Privacy Policy</Link> for details
        <div className={localClasses.cookiesSnackbarOkContainer}>
          <Button
            className={localClasses.cookiesSnackbarOkButton}
            color='primary'
            variant='contained'
            onClick={() => dispatch(closeCookiesSnackbar())}
          >
            Ok
          </Button>
        </div>
      </div>
    </Snackbar>
  )
}

export default CookiesSnackbar
